(function($)
{
    $.extend(true, orion, {
        api: {
            downloads: {}
        }
    });

    let
        api = orion.api.downloads,
        uri = '/api-managed-download-list',
        language = document.querySelector('html').getAttribute('lang');

    function read()
    {
        let
            promise = $.ajax(uri + '-' + language, {
                headers: {
                    'Accept': 'application/json',
                },
                method: 'GET'
            });

        return promise;
    }

    api.read = read;
})(jQuery);
